import React, { useEffect, useState } from 'react'
import {
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
  } from "../../ui/dropdown-menu"
import { Input } from '../../ui/input'
import { Button } from '../../ui/button'
import { Field,Form } from 'react-final-form'
import { useNavigate } from 'react-router-dom';

import { composeValidators, preventNonNumericAndRestrictLength, renderField, required } from "../../../helpers/form-validations"
import { meta } from 'eslint-plugin-prettier'
import { IoIosArrowBack, IoIosArrowDown } from 'react-icons/io'
import { Label } from '../../ui/label'
import { createDistributor, editDistributor, getAllInvestorDetails } from '../../../utils/util'
import AdvancedDropdown from '../../ui/multi-selection-dropdown-menu-with-search'
import { useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { loaderSet } from '../../../context/actions/loaderAction'
import { alertDanger, alertSuccess } from '../../../context/actions/toastAction'
import { template } from 'lodash'
import { nullDistributorInfo } from '../../../context/actions/distributorInfoAction'
import Loader from '../../loader'
import PhoneInput from 'react-phone-input-2';

import 'react-phone-input-2/lib/semantic-ui.css'
import AdvancedDropdownWithCheckbox from '../../ui/multi-selection-dropdown-menu-with-search-and-checkbox'

const CreateDistributor = ({back,getAllDistributor,setActiveTab}) => {
const distributorInfo = useSelector(state => state.distributorInfo)
const [allInvestor,setAllInvestor]=useState([])
// Function to handle option select/deselect
const allEmailTemplateDetailsForDropdown=useSelector(state=>state.allEmailTemplateDetails)
const allSchemeDetailsForDropdown=useSelector(state=>state.allSchemeDetails)
const [searchParams] = useSearchParams();
const allInvestorDetails = useSelector((state) => state.allInvestorDetails);
const dispatch=useDispatch()
const navigate = useNavigate();
const [isLoading,setIsLoading]=useState(false)
// Get the 'user_id' and 'action_type' from URL params
const userId = searchParams.get('user_id');
const actionType = searchParams.get('action_type');
useEffect(() => {
  console.log('User ID:', userId);
  console.log('Action Type:', actionType);
  // You can use these values as needed, for example, making API calls
  console.log("from redux distributor Info",distributorInfo)
  console.log("selectedInvestorName",selectedInvestorOptions,)
}, [userId, actionType]);
  const [selectedSchemeOptions, setSelectedSchemeOptions] = useState([]);
  const [schemeOption,setSchemeOption]=useState( 
    allSchemeDetailsForDropdown && allSchemeDetailsForDropdown.length>0 ?
    allSchemeDetailsForDropdown.map((scheme,index)=>(
      scheme.scheme_name
    ))
    :
    ["option 1","option 2","option 3"])
    const [classOption, setClassOption] = useState([]);

     useEffect(() => {
      if (allSchemeDetailsForDropdown && allSchemeDetailsForDropdown.length > 0) {
        const filteredClassOptions = allSchemeDetailsForDropdown
          .filter((scheme) => 
            scheme.scheme_name === selectedSchemeOptions[0] && 
            scheme.scheme_class !== undefined && 
            scheme.scheme_class !== null
          )
          .flatMap((scheme) => scheme.scheme_class); // Flatten nested scheme_class arrays
    
        setClassOption(filteredClassOptions);
      }
    }, [allSchemeDetailsForDropdown, selectedSchemeOptions]);
    

  const [selectedClassOptions, setSelectedClassOptions] = useState([]);
  // const [selectedInvestorOptions, setSelectedInvestorOptions] = useState(() => {
  //   if (distributorInfo && actionType==="View" && actionType ==="Edit") {
  //     return (distributorInfo[0].investors).map((investor) => investor.investor_name);
  //   }
  //   return [];
  // });
 
  const [selectedInvestorOptions, setSelectedInvestorOptions]=useState([])
  const [phoneNumberWithCountryCode,setPhoneNumberWithCountryCode]=useState(distributorInfo ? distributorInfo?.distributor?.mobile_number:null)
 

  const getAllInvestor=async()=>{
    const payload={
      page_no : 1,
       per_page :10,
        user_type:"investor"
    }
    try {
      const response = await getAllInvestorDetails(payload)
      if(response){
        // console.log("investor data",response?.data,(response?.data).map((investor,index)=>(`${investor.portfolio_number}-${investor.name}`)))
       setAllInvestor((response?.data).map((investor,index)=>(investor.name)))
      }
    } catch (error) {
      console.log("Error in get investor api",error)
    }
  }
  useEffect(()=>{
  getAllInvestor();
  console.log("scheme.scheme_name===selectedSchemeOptions && scheme.scheme_class",selectedSchemeOptions)
  if(allSchemeDetailsForDropdown && allSchemeDetailsForDropdown.length>0){
    const classoption=allSchemeDetailsForDropdown.filter((scheme,index)=>{
      console.log("scheme.scheme_name === selectedSchemeOptions",scheme.scheme_name,selectedSchemeOptions[0])
      return scheme.scheme_name === selectedSchemeOptions[0] && scheme.scheme_class !== undefined && scheme.scheme_class !== null;
    }).map((scheme,index)=>scheme.scheme_class)
    
    console.log("scheme.scheme_name===selectedSchemeOptions && scheme.scheme_class",classoption)
  }
  },[selectedSchemeOptions])

  const [emailTemplateOption,setEmailTemplateOption]=useState([])
  const [selectedEmailTemplateOptions,setSelectedEmailTemplateOptions]=useState([])

  useEffect(() => {
   if (allEmailTemplateDetailsForDropdown && allEmailTemplateDetailsForDropdown.length > 0) {
     const filteredEmailTemplateOptions =  allEmailTemplateDetailsForDropdown.filter(emailTemplate=>emailTemplate.template_name!==null).map((emailTemplate) => {
      return emailTemplate.template_name;
    });
       
       
     setEmailTemplateOption(filteredEmailTemplateOptions)
   }
 }, [allEmailTemplateDetailsForDropdown]);

 const [investorOption, setInvestorOption] = useState([]);
 useEffect(() => {
if(allInvestorDetails && allInvestorDetails.length>0){
  const innerBlockInvestorList = allInvestorDetails
  .filter((investor) => {
    // Ensure that investor.schemes is an array
    if (Array.isArray(investor.schemes)) {
      // Check if any of the schemes match the selected scheme and class
      return investor.schemes.some((scheme) => {
        const schemeMatch = selectedSchemeOptions.includes(
          scheme.scheme_name
        );
        const classMatch = selectedClassOptions.includes(
          scheme.scheme_class
        );

        // Only include if both scheme and class match
        return schemeMatch && classMatch;
      });
    }
    return false; // If investor.schemes is not an array, exclude the investor
  })
  .flatMap((investor) =>
    
    {
     
      console.log("HIIIHIII")

      return investor.schemes
      .filter((scheme) => {
        const schemeMatch = selectedSchemeOptions.includes(scheme.scheme_name);
        const classMatch = selectedClassOptions.includes(scheme.scheme_class);
        console.log("HIIIHIII22222")
        // Include only if both scheme and class match
        return schemeMatch && classMatch;
      })
      .map((scheme) => `${scheme.folio_number}-${investor.name}`)
    
    
    }

  
  ); // Get the names of filtered investors

// Do something with the filtered list (innerBlockInvestorList)
setInvestorOption(innerBlockInvestorList);
console.log("innerBlockInvestorList", innerBlockInvestorList);
}
 }, [selectedClassOptions, selectedSchemeOptions, allInvestorDetails]);

 const [investorsForDistributor, setInvestorsForDistributor] = useState([]);





 const [ selectedInvestorAgainstSchemeAndClass, setSelectedInvestorAgainstSchemeAndClass]=useState([])

 useEffect(() => {
  // Check if distributorInfo and investors are available
  if (distributorInfo?.investors) {
    const initialInvestors = distributorInfo.investors.map(investor => {
      // Extract the scheme and class from each investor
      return investor.schemes.map(scheme => {
        const combinedValue = `${scheme.folio_number}-${investor.name}-${scheme.scheme_name}-${scheme.scheme_class}`;
        return combinedValue;
      });
    }).flat(); // Flatten the array of arrays

    // Set the initial state without duplicates
    setSelectedInvestorAgainstSchemeAndClass(prev => {
      const newInvestors = initialInvestors.filter(value => !prev.includes(value));
      return [...prev, ...newInvestors];
    });
  }
}, [distributorInfo]); // Dependency array includes distributorInf


useEffect(()=>{
  setSelectedInvestorOptions([])
   },[selectedClassOptions])
   useEffect(()=>{
    setSelectedInvestorOptions([])
    setSelectedClassOptions([])
     },[selectedSchemeOptions])
    

//  useEffect(()=>{
//   if (selectedSchemeOptions?.length>0 && selectedClassOptions?.length>0 && selectedInvestorOptions.length>0){
//     console.log("selectedInvestorOptions.length>0",selectedInvestorOptions)
//     const combinedValue = `${selectedInvestorOptions}-${selectedSchemeOptions}-${selectedClassOptions}`;
//        // Corrected combinedValue construction
//       //  const combinedValue = selectedInvestorOptions.map(investor => (
//       //   `${investor}-${selectedSchemeOptions.join(",")}-${selectedClassOptions.join(",")}`
//       // ));
//     setSelectedInvestorAgainstSchemeAndClass((prev) => {
//       if (!prev.includes(combinedValue)) {
//         return [...prev, combinedValue]; // Add only if it's not a duplicate
//       }
//       return prev; // If it's already in the array, return the current state
//     });
//   }

// // setSelectedInvestorOptions([])

//  },[selectedInvestorOptions])

useEffect(() => {
  if (
    selectedInvestorOptions?.length > 0 &&
    selectedSchemeOptions?.length > 0 &&
    selectedClassOptions?.length > 0
  ) {
    const localInvestorOptions=selectedInvestorOptions
    const newCombinedValues = localInvestorOptions.map((investor) => {
      // Ensure each investor string is valid before processing
      if (investor.trim()) {
        // Create a combined value for the current investor
        return `${investor}-${selectedSchemeOptions.join(",")}-${selectedClassOptions.join(",")}`;
      }
      return null; // Skip invalid entries
    }).filter(Boolean); // Remove null entries

    // Update state with unique combined values
    setSelectedInvestorAgainstSchemeAndClass((prev) => {
      const valueSet = new Set(prev); // Convert existing state to a Set
      newCombinedValues.forEach((value) => valueSet.add(value)); // Add new values to the Set
      return Array.from(valueSet); // Convert back to an array
    });
  }
  setSelectedInvestorOptions([])
}, [selectedInvestorOptions, selectedSchemeOptions, selectedClassOptions]);



 const handleRemoveSchemeAndClass = (indexToRemove) => {
  console.log("indextoremove",indexToRemove)
  setSelectedInvestorAgainstSchemeAndClass((prev) => prev.filter((_, index) => index !== indexToRemove));
};

// useEffect(() => {
//   if (
//     // selectedInvestorAgainstSchemeAndClass && selectedInvestorAgainstSchemeAndClass.length > 0
//     selectedInvestorAgainstSchemeAndClass
//   ) {
//     console.log("selectedInvestorAgainstSchemeAndClass.reduce",selectedInvestorAgainstSchemeAndClass)
//     // Create an object to accumulate schemes by user_id
//     const innerInvestorAgainstSchemeAndClass = selectedInvestorAgainstSchemeAndClass.reduce((acc, item) => {
//       // Extract portfolio number
//       const portfolioNumber = item.split("-")[0];
//       const scheme_name= item.split("-")[2]
//       const scheme_class= item.split("-")[3]

//       // Find the matching user
//       // const matchedUser = allInvestorDetails.schemes.find(
//       //   (detail) => detail.portfolio_number === portfolioNumber
//       // );


//       // const matchedUser = allInvestorDetails.find((user) => 
//       //   Array.isArray(user.schemes) &&
//       //   user.schemes.some((detail) => detail.portfolio_number === portfolioNumber)
//       // );
      

//       const matchedUser = allInvestorDetails.find((user) => 
//         Array.isArray(user.schemes) &&
//         user.schemes.some((detail) => detail.folio_number === portfolioNumber && detail?.scheme_name===scheme_name && detail?.scheme_class===scheme_class)
//       );
//       // Optional: To get the specific matching scheme details
//       const matchedScheme = matchedUser?.schemes.find(
//         (detail) => detail.folio_number === portfolioNumber
//       );
      
//       console.log("Matched User:", matchedUser);
//       console.log("Matched Scheme:", matchedScheme);
      

//       if (matchedUser) {
//         // Define the scheme
//         const scheme = {
//           scheme_name: item.split("-")[2],
//           scheme_class: item.split("-")[3]
//         };

//         // If the user_id already exists, push the scheme to the existing array
//         const existingUser = acc.find(user => user.user_id === matchedUser.user_id);
//         if (existingUser) {
//           existingUser.schemes.push(scheme);
//         } else {
//           // Otherwise, create a new entry with this user and scheme
//           acc.push({
//             user_id: matchedUser.user_id,
//             schemes: [scheme]
//           });
//         }
//       }

//       return acc;
//     }, []);
//    setInvestorsForDistributor(innerInvestorAgainstSchemeAndClass)
//     console.log("innerInvestorAgainstSchemeAndClass", innerInvestorAgainstSchemeAndClass);
//   }
// }, [selectedInvestorAgainstSchemeAndClass, allInvestorDetails]);

useEffect(() => {
  if (selectedInvestorAgainstSchemeAndClass?.length > 0) {
    const innerInvestorAgainstSchemeAndClass = selectedInvestorAgainstSchemeAndClass.reduce((acc, item) => {
      // Split the combined value
      const [portfolioNumber, investorName, schemes, classes] = item.split("-");

      if (portfolioNumber && investorName && schemes && classes) {
        // Split schemes and classes into arrays
        const schemeNames = schemes.split(",");
        const classNames = classes.split(",");

        // Match the user and schemes
        const matchedUser = allInvestorDetails.find((user) =>
          user.schemes.some((scheme) =>
            schemeNames.includes(scheme.scheme_name) &&
            classNames.includes(scheme.scheme_class) &&
            scheme.folio_number === portfolioNumber
          )
        );

        if (matchedUser) {
          schemeNames.forEach((schemeName) => {
            classNames.forEach((schemeClass) => {
              const scheme = { scheme_name: schemeName, scheme_class: schemeClass };

              // Find existing user in acc
              const existingUser = acc.find((user) => user.user_id === matchedUser.user_id);
              if (existingUser) {
                existingUser.schemes.push(scheme);
              } else {
                // Add new user with schemes
                acc.push({
                  user_id: matchedUser.user_id,
                  schemes: [scheme],
                });
              }
            });
          });
        }
      }

      return acc;
    }, []);

    setInvestorsForDistributor(innerInvestorAgainstSchemeAndClass);
    console.log("Processed Investors and Schemes:", innerInvestorAgainstSchemeAndClass);
  }
}, [selectedInvestorAgainstSchemeAndClass, allInvestorDetails]);


    const onSubmit=async(values)=>{
      setIsLoading(true)
    console.log("distributor info",distributorInfo)
      const payload={
        user_id:userId?userId:"",
        
        "user_email": values?.email || distributorInfo?.distributor.user_email, 
        "mobile_number":phoneNumberWithCountryCode || distributorInfo?.distributor?.mobile_number,
        "user_type": "distributor",
        "name": values?.distributorName || distributorInfo?.distributor?.name ,
        "role_name": "distributor",
        "template_name":selectedEmailTemplateOptions?.length>0  ?selectedEmailTemplateOptions[0] : null,
        contact_person_name:values.contact_person_name || distributorInfo?.distributor?.contact_person_name,
        designation:values.designation || distributorInfo?.distributor?.designation,
       
        // "investors":[
        //   {
        //     user_id: "user_764104ec",
        //     // name: "Investor1",
        //     schemes: [
        //       { scheme_name: "Sekar fund", scheme_class: "C" },
        //       { scheme_name: "Madhan Fund", scheme_class: "B" },
        //       { scheme_name: "Vasuki XVI", scheme_class: "A" }
        //     ]
        //   },
        //   {
        //     user_id: "user_2b67dde6",
        //     // name: "Investor2",
        //     schemes: [
        //       { scheme_name: "Madhan Fund", scheme_class: "A" },
        //       { scheme_name: "Vasuki India", scheme_class: "A" }
        //     ]
        //   },
         
        // ]
        investors:investorsForDistributor
        
    }

            try {
              if(actionType!=="Edit" && actionType!=="View")
            {  const response=await createDistributor(payload)
              console.log("resposne of distributor api",response)
            if( response.code ===500){
                         dispatch(alertDanger(response.message))
                          setIsLoading(false)
                         return
                       }
                       if( response.code ===404){
                         dispatch(alertDanger(response.message))
                          setIsLoading(false)
                         return
                       }
                       if( response.code ===400){
                         dispatch(alertDanger(response.message))
                          setIsLoading(false)
                         return
                       }
             if(response.code===200){
              setActiveTab("distributor")
               getAllDistributor()
               dispatch(alertSuccess("Successfully Created Distributor"))
               navigate('/admin');
               back()
                setIsLoading(false)
                return
              }
            }
            if(actionType==="Edit"){
              const response=await editDistributor(payload)
              console.log("resposne of edit distributor api",response)
         if( response.code ===500){
                      dispatch(alertDanger(response.message))
                       setIsLoading(false)
                      return
                    }
                    if( response.code ===404){
                      dispatch(alertDanger(response.message))
                       setIsLoading(false)
                      return
                    }
                    if( response.code ===400){
                      dispatch(alertDanger(response.message))
                       setIsLoading(false)
                      return
                    }
               if(response.code===200){
                setActiveTab("distributor")
                 getAllDistributor()
                 dispatch(alertSuccess("Successfully Updated Distributor"))
                 navigate('/admin');
                  setIsLoading(false)
                  // back()
                  return
                }
             
            }
            } catch (error) {
              dispatch(alertDanger("Error In Create Distributor"))
              console.log("Error in create distributor api",error)
              setIsLoading(false)
            } finally {
              // setTimeout(() => dispatch(loaderSet(false)), 1000); // Adds a slight delay
            }
    }

  return (
    <>

{
        isLoading && <Loader/>
      }
     
          <Form
          onSubmit={onSubmit}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>



<div className="w-full flex flex-col p-6  bg-[#FFFFFF] rounded-md gap-8">
{ (actionType==="Edit" || actionType==="View") &&
<div className=' w-full flex justify-end items-center' >
<Button
        variant="outline"
        type="button"
        size="sm"
        className=" h-10  gap-1 text-sm w-max self-start "
        onClick={()=>{
          setActiveTab("distributor")
          // dispatch(loaderSet(true))
          dispatch(nullDistributorInfo())
          navigate("/admin")
        }
        } 
      >
        <IoIosArrowBack />
        Back
      </Button>
</div>
      
      } 
{/* <div className="flex w-full justify-between items-center gap-4 ">


<div className="flex flex-col  w-[49%] gap-2">
<Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor="userType">User Type</Label>
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button id="userType" variant="outline" size="lg" className="h-10 gap-1 w-full text-md flex border-[#3a5dd1] justify-between">
        <span className="sr-only sm:not-sr-only">User Type</span>
    
        <span className="ml-1 text-[#0D215C]"><IoIosArrowDown /></span>
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent  className={"w-full"} >
      <DropdownMenuLabel>Scheme Class</DropdownMenuLabel>
      <DropdownMenuSeparator />
      <DropdownMenuCheckboxItem checked>Option 1</DropdownMenuCheckboxItem>
      <DropdownMenuCheckboxItem>Option 2</DropdownMenuCheckboxItem>
      <DropdownMenuCheckboxItem>Option 3</DropdownMenuCheckboxItem>
    </DropdownMenuContent>
  </DropdownMenu>
</div>

</div>
<div className='w-full h-2 rounded-md bg-muted' ></div> */}
  <div className="flex w-full justify-between items-center gap-4 ">

    {/* Ticker name Input field */}
   

    <div className="gap-2 flex flex-col w-[49%]">
    <Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor="distributorName">Distributor Name <span className=" text-red-600">*</span></Label>
      <Field
        id="distributorName"
        type="text"
        name="distributorName"
        placeholder="Distributor Name"
        actionType={actionType}
        info={distributorInfo &&   distributorInfo?.distributor?.name}
        disabled={(actionType==="View" || actionType==="Edit") && true}
        validate={
          (actionType !== "Edit" && actionType !== "View") ? composeValidators(required) : undefined
        }          
        component={renderField} // Correct usage of renderField
        className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
      />
      {/* Reserve space for the error message */}
      {meta.touched && meta.error && (
  <p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{meta.error}</p>
)}
    </div>
   <div className="gap-2 w-[49%] flex flex-col ">
   <Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor="contact_person_name">Contact Person Name<span className=" text-red-600">*</span></Label>
     <Field
       id="contact_person_name"
       type="text"
       name="contact_person_name"
       placeholder="Enter Name"
       actionType={actionType}
       info={  distributorInfo &&  distributorInfo?.distributor?.contact_person_name}
       disabled={(actionType==="View" ) && true}
       validate={
        (actionType !== "Edit" && actionType !== "View") ? composeValidators(required) : undefined
      }        
       component={renderField} // Correct usage of renderField
       className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
     />
   
     {meta.touched && meta.error && (
   <p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{meta.error}</p>
   )}
   </div>
  
  </div>

  <div className="flex w-full justify-between items-center gap-4 ">

    {/* Ticker name Input field */}
    <div className="gap-2 w-[49%] flex flex-col ">
    <Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor="email">Email <span className=" text-red-600">*</span></Label>
      <Field
        id="email"
        type="text"
        name="email"
        placeholder="Enter Email"
        actionType={actionType}
        info={distributorInfo &&   distributorInfo?.distributor?.user_email}
        disabled={(actionType==="View" || actionType==="Edit" ) && true}
        validate={
          (actionType !== "Edit" && actionType !== "View") ? composeValidators(required) : undefined
        }          
        component={renderField} // Correct usage of renderField
        className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
      />
      {/* Reserve space for the error message */}
      {meta.touched && meta.error && (
  <p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{meta.error}</p>
)}
    </div>

    {/* <div className="gap-2 w-[49%] flex flex-col ">
    <Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor="phoneNumber">Phone Number <span className=" text-red-600">*</span></Label>
      <Field
        id="phoneNumber"
        type="text"
        name="phoneNumber"
        placeholder="Phone Number"
        actionType={actionType}
        info={distributorInfo &&  distributorInfo?.distributor?.mobile_number}
        disabled={actionType==="View" && true}
        // validate={
        //   actionType !== "Edit" ? composeValidators(required) : undefined
        // }          
        onKeyDown={(event) => preventNonNumericAndRestrictLength(event, 10)}
        component={renderField} // Correct usage of renderField
        className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
      />
   
      {meta.touched && meta.error && (
  <p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{meta.error}</p>
)}
    </div> */}
  
  <div className="gap-2 w-[49%] flex flex-col ">
    <Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor="phoneNumber">Phone Number <span className=" text-red-600">*</span> </Label>
    
<div
  style={{
    position: 'relative',
    width: '100%',
    // You can also add media queries for extra control over different screen sizes
  }}
>
  <PhoneInput
    country={'in'} // Set the default country code
    value={phoneNumberWithCountryCode} // Value to display
    onChange={(value) => {
      console.log("Phone Number", value);
      setPhoneNumberWithCountryCode(value);
    }} // Update state on change
    disableSearchIcon
    disabled={actionType === "View"} // Disable the field if actionType is 'View'
    placeholder="Enter phone number"
    enableSearch
    countryCodeEditable={false} // Display the country calling code and make it non-editable

    // Input style
    inputStyle={{
      width: '100%',
      height: '2.25rem',
      padding: '0.5rem',
      paddingLeft: '3.5rem', // Space for the country code button
      borderRadius: '0.375rem',
      border: '1px solid #3a5dd1',
      display: 'inline-block',
      boxSizing: 'border-box',
    }}

    // Country code button style
    buttonStyle={{
      height: '2.25rem',
      width: '3.5rem',
      padding: '0 0.5rem',
      borderLeft: '1px solid #3a5dd1',  // Add border only on the left
      borderTop: '1px solid #3a5dd1',   // Add border only on the top
      borderBottom: '1px solid #3a5dd1', // Add border only on the bottom
      borderRight: 'none',               // Remove border on the right
      outline: 'none',
      boxSizing: 'border-box',
      
      // Border radius
      borderTopLeftRadius: '0.375rem',  // Rounded top-left corner
      borderBottomLeftRadius: '0.375rem', // Rounded bottom-left corner
      borderTopRightRadius: '0',        // Square top-right corner
      borderBottomRightRadius: '0',     // Square bottom-right corner
    }}
    
    

    dropdownStyle={{
      maxHeight: '300px',
      overflowY: 'auto',
    
      top: '100%',
      left: 0,
     
    }}

    // Search bar styles
    searchStyle={{
      width: '100%',
      height: '2.25rem',
      padding: '0.5rem',
      borderRadius: '0.375rem',
      border: '1px solid #3a5dd1',
      boxSizing: 'border-box',
    }}
  />
</div>

      {/* Reserve space for the error message */}
      {meta.touched && meta.error && (
  <p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{meta.error}</p>
)}
    </div>

  </div>

  <div className="flex w-full justify-between items-center gap-4 ">

{/* Ticker name Input field */}
<div className="gap-2 w-full flex flex-col ">
<Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor="designation">Designation<span className=" text-red-600">*</span></Label>
  <Field
    id="designation"
    type="text"
    name="designation"
    placeholder="Enter Designation"
    actionType={actionType}
    info={distributorInfo &&   distributorInfo?.distributor?.designation}
    disabled={(actionType==="View"  ) && true}
    validate={
      (actionType !== "Edit" && actionType !== "View") ? composeValidators(required) : undefined
    }          
    component={renderField} // Correct usage of renderField
    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
  />
  {/* Reserve space for the error message */}
  {meta.touched && meta.error && (
<p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{meta.error}</p>
)}
</div>





</div>
  <div className="flex w-full justify-between items-center gap-4 ">

    

<div className="flex flex-col  w-[49%] gap-2">
  
  <AdvancedDropdown
  name="Scheme"
  id="scheme"
   options={schemeOption}
   selectedOptions={selectedSchemeOptions}
   setSelectedOptions={setSelectedSchemeOptions}
   placeholder="Scheme"
   select={"single"}
   disabled={actionType==="View" && true}
   required={true}
 />
 {/* {errors.schemeError && (
          <p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{errors.schemeError}</p>
        )} */}
</div>

    <div className="flex flex-col  w-[49%] gap-2">
  
       <AdvancedDropdown
       name="Class"
       id="class"
        options={classOption}
        selectedOptions={selectedClassOptions}
        setSelectedOptions={setSelectedClassOptions}
        placeholder="Class"
        select={"single"}
        disabled={selectedSchemeOptions.length===0 && true}
        required={true}
      />
      {/* {errors.classError && (
          <p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{errors.classError}</p>
        )} */}
    </div>

   
    
  </div>
    

 


 
{/* 
<div className='w-full h-2 rounded-md bg-muted' ></div>


<div className=' w-full flex flex-col min-h-32' >
   <div className=' flex flex-row justify-between' >
   <span className="text-start text-[#0D215C] font-bold text-lg" >Scheme Documents</span>
<Button type="submit" className="w-[20%] bg-[#0D215C]  " >
                      Add Document
                    </Button>
   </div>
</div> */}

<div className='flex w-full justify-between items-center gap-4' >
<div className="flex flex-col  w-[49%] gap-2">
  
  <AdvancedDropdownWithCheckbox

  name="Investor"
  id="investor"
   options={investorOption}
   selectedOptions={selectedInvestorOptions}
   setSelectedOptions={setSelectedInvestorOptions}
   placeholder="Investor"
   select={"multiple"}
   selectedClassOptions={selectedClassOptions?.length>0 ?selectedClassOptions[0]:null}
  combinationOfFolioNameSchemeClass={selectedInvestorAgainstSchemeAndClass?.length>0 ?selectedInvestorAgainstSchemeAndClass:[]}
  setCombinationOfFolioNameSchemeClass={setSelectedInvestorAgainstSchemeAndClass}
  selectedSchemeOptions={selectedSchemeOptions?.length>0 ?selectedSchemeOptions[0]:null}
   required={true}
   disabled={(selectedClassOptions.length===0 || selectedSchemeOptions.length===0)&& true}
 />
 {/* {errors.investorError && (
     <p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{errors.investorError}</p>
   )} */}
</div>
</div>
{ selectedInvestorAgainstSchemeAndClass?.length>0 && 
  (
  <div className="flex w-full  items-center gap-4 border border-[#3a5dd1] rounded-lg  p-10 flex-wrap ">
    {selectedInvestorAgainstSchemeAndClass?.length > 0 && selectedInvestorAgainstSchemeAndClass.map((item, index) => (
        <div   key={index} className="flex gap-8 justify-center items-center bg-[#0D215C] text-white text-sm rounded-xl px-4 py-2 font-bold  ">
          <span>{item}</span>
          <div
  className={`rounded-full bg-red-500 flex items-center justify-center h-5 w-5 p-1 text-xs cursor-${actionType === 'View' ? 'default' : 'pointer'}`}
  onClick={actionType !== 'View' ? () => handleRemoveSchemeAndClass(index) : undefined}
>
  {"X"}
</div>

          </div>
      ))}
    </div>
    )
    }

<div className='w-full h-2 rounded-md bg-muted ' ></div>
<div className='flex w-full justify-end gap-2' >
{( actionType!=="View" && actionType!=="Edit") &&  <div className=" w-[20%] h-10 gap-2">

<AdvancedDropdown
  name="Email Template"
  id="emailTemplate"
   options={emailTemplateOption}
   selectedOptions={selectedEmailTemplateOptions}
   setSelectedOptions={setSelectedEmailTemplateOptions}
   placeholder="Email Template"
   select={"single"}
   label={false}
//    disabled={selectedSchemeOptions.length===0 && true}
 />  
</div>}
{ actionType!=="View" &&  <Button type="submit" className="w-[20%] h-10 bg-[#0D215C] self-end " >
                     { actionType==="Edit"?"Save Changes":"Create User"}
                    </Button>}
</div>
</div>

            </form>
          )}
        />
    </>
  )
}

export default CreateDistributor